// Mapa rota → grupo/rótulo do menu lateral. Fonte única para o menu
// (grupo que abre sozinho) e para a trilha da barra superior.

// Grupos recolhíveis e as rotas de cada um
export const GROUP_ROUTES = {
  management: ["/", "/moments", "/supervision", "/reports", "/ratings", "/wallets", "/call-historicals"],
  campaigns: ["/campaigns", "/contact-lists", "/files", "/campaigns-config"],
  billing: ["/billing-rules", "/invoice-campaigns", "/network-alerts", "/erp-writeback", "/hotspot"],
  automation: ["/flowbuilder", "/birthday-settings", "/flowbuilders", "/phrase-lists", "/prompts", "/ai-learning"],
  channels: ["/connections", "/messages-api", "/meta-templates", "/queue-integration"],
  config: ["/queues", "/users", "/financeiro", "/settings"],
};

// Seções fixas (sem submenu) que também têm título no menu
const SECTION_ROUTES = {
  attendance: ["/tickets", "/contacts", "/kanban", "/chats", "/schedules", "/quick-messages", "/tags"],
  platform: ["/companies", "/reseller-finance", "/allconnections", "/announcements", "/ai-platform", "/system-resources"],
};

const GROUP_LABEL_KEYS = {
  attendance: "mainDrawer.listItems.attendance",
  management: "mainDrawer.listItems.management",
  campaigns: "mainDrawer.listItems.campaigns",
  billing: "mainDrawer.listItems.billingGroup",
  automation: "mainDrawer.listItems.automation",
  channels: "mainDrawer.listItems.channelsGroup",
  config: "mainDrawer.listItems.configGroup",
  platform: "mainDrawer.listItems.platform",
};

// Mesmas chaves de tradução que cada item usa em MainListItems
const ITEM_LABEL_KEYS = {
  "/": "mainDrawer.listItems.dashboard",
  "/tickets": "mainDrawer.listItems.tickets",
  "/contacts": "mainDrawer.listItems.contacts",
  "/kanban": "mainDrawer.listItems.kanban",
  "/chats": "mainDrawer.listItems.chats",
  "/schedules": "mainDrawer.listItems.schedules",
  "/quick-messages": "mainDrawer.listItems.quickMessages",
  "/tags": "mainDrawer.listItems.tags",
  "/moments": "mainDrawer.listItems.chatsTempoReal",
  "/supervision": "mainDrawer.listItems.supervision",
  "/reports": "mainDrawer.listItems.reports",
  "/ratings": "mainDrawer.listItems.ratings",
  "/wallets": "mainDrawer.listItems.wallets",
  "/call-historicals": "mainDrawer.listItems.callHistorical",
  "/campaigns": "campaigns.subMenus.list",
  "/contact-lists": "campaigns.subMenus.listContacts",
  "/files": "mainDrawer.listItems.files",
  "/campaigns-config": "campaigns.subMenus.settings",
  "/billing-rules": "campaigns.subMenus.billingRules",
  "/invoice-campaigns": "campaigns.subMenus.invoiceCampaigns",
  "/network-alerts": "mainDrawer.listItems.networkAlerts",
  "/erp-writeback": "campaigns.subMenus.erpWriteback",
  "/hotspot": "mainDrawer.listItems.hotspot",
  "/birthday-settings": "mainDrawer.listItems.birthdaySettings",
  "/flowbuilders": "mainDrawer.listItems.flowbuilders",
  "/phrase-lists": "mainDrawer.listItems.phraseLists",
  "/prompts": "mainDrawer.listItems.prompts",
  "/ai-learning": "mainDrawer.listItems.aiLearning",
  "/connections": "mainDrawer.listItems.connections",
  "/messages-api": "mainDrawer.listItems.messagesAPI",
  "/queue-integration": "mainDrawer.listItems.queueIntegration",
  "/meta-templates": "campaigns.subMenus.metaTemplates",
  "/queues": "mainDrawer.listItems.queues",
  "/users": "mainDrawer.listItems.users",
  "/financeiro": "mainDrawer.listItems.financeiro",
  "/settings": "mainDrawer.listItems.settings",
  "/helps": "mainDrawer.listItems.helps",
  "/companies": "mainDrawer.listItems.companies",
  "/reseller-finance": "mainDrawer.listItems.resellerFinance",
  "/allconnections": "mainDrawer.listItems.allConnections",
  "/announcements": "mainDrawer.listItems.annoucements",
  "/ai-platform": "mainDrawer.listItems.aiPlatform",
  "/system-resources": "mainDrawer.listItems.systemResources",
};

const matches = (pathname, route) =>
  route === "/" ? pathname === "/" : pathname === route || pathname.startsWith(`${route}/`);

/**
 * Trilha da rota atual com os rótulos do menu: `{ group, title }`.
 * Cada campo vem `null` quando a rota não está no menu (quem chama decide o fallback).
 */
export function getMenuTrail(pathname, translate) {
  const path = String(pathname || "/").toLowerCase() || "/";
  const groups = { ...SECTION_ROUTES, ...GROUP_ROUTES };
  const groupId = Object.keys(groups).find((id) => groups[id].some((route) => matches(path, route)));
  const itemRoute = Object.keys(ITEM_LABEL_KEYS).find((route) => matches(path, route));
  return {
    group: groupId ? translate(GROUP_LABEL_KEYS[groupId]) : null,
    title: itemRoute ? translate(ITEM_LABEL_KEYS[itemRoute]) : null,
  };
}
